<template>
  <permission-guard situation="glossary_management">
    <template>
      <router-link class="d-block mb-2" to="/admin/glossary"
        >← 用語集設定に戻る</router-link
      >
      <h2 class="headline mb-3">用語作成</h2>
      <glossary-phrase-form :glossaryPhrase="glossaryPhrase" @update-glossary-phrase="updateGlossaryPhrase" @save-glossary-phrase="createGlossaryPhrase" />
    </template>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import GlossaryPhraseForm from './GlossaryPhraseForm'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    PermissionGuard,
    GlossaryPhraseForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '用語作成',
      glossaryPhrase: {
        name: null,
        readingJa: null,
        content: null,
        glossaryPhraseLinks: []
      }
    }
  },
  methods: {
    formatQuery (glossaryPhrase) {
      let queryObj = glossaryPhrase
      if (glossaryPhrase.glossaryPhraseLinks) {
        const glossaryPhraseLinksAttributes = glossaryPhrase.glossaryPhraseLinks.map(
          (item, index) => {
            let obj = {
              priority: index,
              postId: item.postId,
              title: item.title,
              url: item.url,
              _destroy: item.destroy
            }
            if (item.id) {
              Object.assign(obj, { id: item.id })
            }
            return obj
          }
        )
        queryObj.glossaryPhraseLinksAttributes = glossaryPhraseLinksAttributes
      }
      return { glossaryPhrase: queryObj }
    },
    createGlossaryPhrase () {
      const query = this.formatQuery(this.glossaryPhrase)
      axios.post('/api/glossary_phrases', query).then(
        async () => {
          const payload = {
            status: 200,
            message: '新規用語を作成しました。'
          }
          await this.$store.dispatch(
            'SystemMessageStore/createMessage',
            payload
          )
          this.$router.push('/admin/glossary')
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateGlossaryPhrase (glossaryPhrase) {
      this.glossaryPhrase = Object.assign({}, glossaryPhrase)
    }
  }
}
</script>
